import StayOrLeaveOptionJson from './interfaces/StayOrLeaveOptionJson'

export default class StayOrLeaveOption {
  enabled: boolean

  constructor(enabled: boolean) {
    this.enabled = enabled
  }

  static fromJson(data: StayOrLeaveOptionJson) {
    return new this(data.enabled)
  }
}
